import { jsx as _jsx } from "react/jsx-runtime";
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Patt... Remove this comment to see the full error message
import UrlPattern from 'PatternValidationJS/patterns/Url';
const ROBOTS_DIRECTIVES = ['follow', 'nofollow', 'noindex'];
const validators = {
  Location: value => {
    return typeof value === 'string' && UrlPattern.test(value, {
      requireProtocol: true
    });
  },
  'X-Robots-Tag': value => {
    if (!Array.isArray(value)) {
      value = [value];
    }

    return value.every(_value => ROBOTS_DIRECTIVES.includes(_value));
  }
};
const formatters = {
  'X-Robots-Tag': value => {
    if (!Array.isArray(value)) {
      value = [value];
    }

    return value.join(',');
  }
};

function PrerenderHeader({
  name,
  value
}) {
  const validator = validators[name];
  const formatter = formatters[name];

  if (validator && !validator(value)) {
    console.error(`PrerenderHeader: Invalid ${name} value ${value.toString()}`);
  }

  if (formatter) {
    value = formatter(value);
  }

  return /*#__PURE__*/_jsx("meta", {
    name: "prerender-header",
    content: `${name}: ${value}`
  });
}

export default PrerenderHeader;